import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link } from 'react-router-dom';
import { logout as logoutAction } from '../../store/user/UserActions';
import { IUser } from '../../store/interface';
import { Container, Col, Row } from 'reactstrap';
import { fetchUserRequest as getUserAction } from '../../store/user/UserActions';
import { listRequest as listUserRequestAction, 
    selectData as selectDataAction, selectedData as selectedAction, selectedClear as selectedClearAction
} from '../../store/userInfo/actions';
import { getSelectedUserInfo } from '../../store/userInfo/selectors';

import NavBar from '../../components/NavBar';
import { Spinner } from 'reactstrap';
interface PropsFromState {
    route: any
    userDB: any
    ui : any
    userInfo: any
}

interface IState {
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    component: any
    logout: typeof logoutAction
    user: any
    login: any
    logged: any
    editProfile: any
    fetchUserRequest : typeof getUserAction
    listUserRequest : typeof listUserRequestAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


class PrivateLayout extends Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
        this.readUserData = this.readUserData.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        //console.log("[User]" + this.props.user);
        this.readUserData();
    }

    readUserData(){
        console.log("read User Data");
        var searchParams: any = {};
        this.props.listUserRequest(searchParams);
    }
    componentWillUnmount(){
    }
    
    render() {
        const Component = this.props.component;
        const route = this.props.route;
        const user = this.props.user;
        const logout = this.props.logout;
        return (

            <Fragment>
                <NavBar
                    editProfileButtonMethod={this.props.editProfile}
                    userDB={this.props.userInfo.byId[0]}
                    isAuthenticated={this.props.logged}
                    authButtonMethod={this.props.logged ? this.props.logout : this.props.login}
                    user={this.props.logged ? { name: user.fullName, displayName: user.fullName, email: user.emailAdd, userRole : user.idToken.userRole} : {}}
                ></NavBar>
                <main role="main">
                    <Container className="bg-light">
                        {
                            this.props.userInfo.byId[0] === undefined ?
                            <div>Loading...Please wait... <Spinner color="warning"/></div>:
                            <Component route={route} />
                        }
                    </Container>
                </main>
                <footer className="footer" style={{backgroundColor:"#45474C", color:"#ffffff", textAlign:"center", padding:"31px 8px 8px 8px"}}>
                    <Row>
                        <Col lg="2" xs="3"></Col>
                        <Col lg="8" xs="6">
                            <ul style={{listStyle:"none", padding: 0}}>
                                <li><a href="https://ultimatespro.com/#/">Back to Public Homepage</a></li>
                                <li><Link to="/how-we-benefits-you">How We Benefits You</Link></li>
                                <li><Link to="/how-it-works">How It Works</Link></li>
                                <li><Link to="/terms-of-use">Terms Of Use</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li ><Link to="/contact-us">Contact Us</Link></li>
                            </ul>
                        </Col>
                        <Col lg="2" xs="3"></Col>
                    </Row>
                    <Row>
                        <Col>
                            <span className="" style={{fontSize:"smaller"}}>© Ultimates Pro Copyrights 2020</span>
                        </Col>
                    </Row>
                </footer>
            </Fragment>
        );
    }
}
const mapStateToProps = (state: ApplicationState) => ({  
    ui: state.userInfo.ui,
    userDB: state.userReducer ,
    userInfo: getSelectedUserInfo(state),
})

const mapDispatchToProps = {
    fetchUserRequest: getUserAction,
    listUserRequest : listUserRequestAction,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrivateLayout)
